import { render, staticRenderFns } from "./DraftMail.vue?vue&type=template&id=4778c292&scoped=true"
import script from "./DraftMail.vue?vue&type=script&lang=js"
export * from "./DraftMail.vue?vue&type=script&lang=js"
import style0 from "./DraftMail.vue?vue&type=style&index=0&id=4778c292&prod&scoped=true&lang=css"
import style1 from "./DraftMail.vue?vue&type=style&index=1&id=4778c292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778c292",
  null
  
)

export default component.exports